import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsSection, SettingsSectionTitleDict} from "../../@const";

export default class StatusesSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Statuses",
            description              : "You have full control over statuses: you can create new (custom) statuses, delete the ones that don't fit you business process, and modify color and labels to reflect your real-life business processes.",
            svgIcon                  : "isvg-statuses",
            settingsUrl              : "settings/statuses",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            typeLabel                : SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS]
        });
    }

}
